import styled from 'styled-components';

import { font14 } from 'approot/shared/styles/typography.style';
import { LinkButton } from 'approot/shared/styles/buttons/link-button.style';

export const FeedbackLink = styled(LinkButton)`
  ${font14}
`;
